// Serviço da timeline do paciente (append-only) + outbox de eventos de domínio.
import { createClient } from '@/lib/supabase/client'
import type { TimelineEvento } from '@/lib/types'

export async function listTimeline(workspaceId: string, pacienteId: string): Promise<TimelineEvento[]> {
  const supabase = createClient()
  const { data, error } = await supabase
    .from('timeline_eventos')
    .select('id, paciente_id, tipo, titulo, descricao, autor_user_id, consulta_id, dados, visibilidade, created_at')
    .eq('workspace_id', workspaceId)
    .eq('paciente_id', pacienteId)
    .order('created_at', { ascending: false })
    .limit(200)
  if (error) throw error
  return (data ?? []) as TimelineEvento[]
}

/** Registra evento na timeline do paciente e no outbox de domínio (não bloqueia o fluxo). */
export async function registrarEvento(params: {
  workspaceId: string
  pacienteId: string
  tipo: string
  titulo: string
  descricao?: string | null
  consultaId?: string | null
  dados?: Record<string, unknown>
  visibilidade?: 'equipe' | 'medicos'
  /** tipo do evento de domínio (ex.: 'patient.created'); omitir para não emitir */
  eventoDominio?: string
}) {
  try {
    const supabase = createClient()
    await supabase.from('timeline_eventos').insert({
      workspace_id: params.workspaceId,
      paciente_id: params.pacienteId,
      tipo: params.tipo,
      titulo: params.titulo,
      descricao: params.descricao ?? null,
      consulta_id: params.consultaId ?? null,
      dados: params.dados ?? {},
      visibilidade: params.visibilidade ?? 'equipe',
    })
    if (params.eventoDominio) {
      await supabase.from('domain_events').insert({
        workspace_id: params.workspaceId,
        tipo: params.eventoDominio,
        entidade: 'pacientes',
        registro_id: params.pacienteId,
        payload: { consulta_id: params.consultaId ?? null, ...params.dados },
      })
    }
  } catch {
    // timeline nunca derruba a ação principal
  }
}
